export default "__VITE_ASSET__WOlvE2QX__"